<template>
  <div class="pushhike-optin">
    <div class="pushhike-optin__content">
      <div
        style="display: flex; align-items: flex-start"
        class="js-pushhike-title-desc-container"
        dir="auto"
      >
        <div style="flex: 1">
          <h2 class="js-pushhike-title pushhike-optin__title" tabindex="-1">
            {{ config.title }}
          </h2>
          <p class="js-pushhike-description pushhike-optin__description">
            {{ config.description }}
          </p>
        </div>
      </div>
      <div class="pushhike-optin__footer">
        <div
          class="pushhike-optin__footer-btn-wrap js-pushhike-btn-container"
          dir="auto"
        >
          <button
            class="js-pushhike-no-button pushhike-optin__button pushhike-optin__no-button"
          >
            {{ config.noButton.label }}
          </button>
          <button
            class="js-pushhike-yes-button pushhike-optin__button pushhike-optin__yes-button"
          >
            {{ config.yesButton.label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>

<style>
@keyframes show-up {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.pushhike-optin {
  all: initial;
  display: block !important;

  width: 420px !important;
  margin: 12px !important;
  box-sizing: border-box !important;
  background: rgb(255, 255, 255) !important;
  border-radius: 4px !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
  align-items: center !important;
  font-size: 14px !important;
  box-shadow: 0px 12px 13px rgba(0, 0, 0, 0.21) !important;
}
.pushhike-optin * {
  width: initial !important;
  font-family: inherit !important;
  letter-spacing: initial !important;
  box-sizing: border-box !important;
  line-height: initial !important;
  font-weight: normal !important;
  -webkit-font-smoothing: initial !important;
  text-shadow: initial !important;
  border: initial !important;
  background: initial !important;
  padding: initial !important;
  text-align: initial !important;
  box-shadow: initial !important;
  min-width: initial !important;
  text-transform: initial !important;
}
.pushhike-optin svg {
  width: initial;
  height: initial;
  stroke: initial;
  fill: initial;
}
@media screen and (max-width: 444px) {
  .pushhike-optin {
    width: calc(100% - 24px) !important;

    top: 0 !important;
    bottom: auto !important;
    left: 0 !important;
  }
}
.pushhike-optin__content {
  padding: 16px !important;
}
.pushhike-optin__title {
  text-transform: initial !important;
  text-align: initial !important;
  letter-spacing: 0.3px !important;
  font-size: 16px !important;
  margin-top: 0 !important;
  margin-bottom: 8px !important;
  color: #343946 !important;
  font-weight: 500 !important;
  padding: 0 !important;
}
.pushhike-optin__description {
  color: #637381 !important;
  margin: 0 !important;
  padding: 0 !important;
  font-size: inherit !important;
}
.pushhike-optin__image {
  border-radius: 50% !important;
  flex-shrink: 0 !important;
  margin-right: 16px !important;
  padding: 8px !important;
}
.pushhike-optin__image img {
  width: 40px !important;
}
.pushhike-optin__button {
  width: initial !important;
  min-width: initial !important;
  height: initial !important;
  min-height: initial !important;
  text-transform: initial !important;
  margin: initial !important;
  cursor: pointer !important;
  font-size: inherit !important;
  padding: 6px 20px !important;
  max-width: 150px !important;
  border-radius: 4px !important;
  border: none !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.pushhike-optin__yes-button {
  background: #2e5fdc !important;
  color: white !important;
}
.pushhike-optin__no-button {
  background: transparent !important;
  border: 0 !important;
  color: #637381 !important;
}
.pushhike-optin__footer {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  margin-top: 16px !important;
}
.pushhike-optin__footer-btn-wrap {
  display: flex !important;
  align-items: center !important;
}
</style>
